import { Fragment, useEffect, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { WrongInvoiceService } from '../WrongInvoiceService';
import { TenantCompanyService } from '../../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { AppStorage } from '../../../../service/UserStorage';

import { FormatDisplay } from '../../../../shared/format';

import { ToastService } from '../../../../AppToast';
import { ConfirmDialogService } from '../../../../AppConfirmDialog';

import { useForm } from '../../../../shared/hooks/Form';
import { useCellEditing } from '../../../../shared/hooks/CellEditing';
import { useSign } from '../../../../shared/component/Sign';

import { DialogSelectInvoice } from '../../../hoa-don/component/DialogSelectInvoice';
import { get } from 'http';
import { TaxAuthorityService } from '../../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TaxAuthorityService';

export const DialogCrup = (props) => {

  const { display, setDisplay, selectedItem, reloadLazyData } = props;

  const [tenantData, setTenantData] = useState(null);

  const [submitting, setSubmitting] = useState(null);
  const [wrongInvoiceDetail, setWrongInvoiceDetail] = useState([]);
  const [invoiceDetailValidate, setInvoiceDetailValidate] = useState(null);

  const [firstId, setFirstId] = useState(null);
  const [disableProperty, setDisableProperty] = useState(true);
  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(null);
  const [type, setType] = useState(1)
  const types = [
    { value: 1, label: 'Thông báo của Người nộp thuế' },
    { value: 2, label: 'Thông báo của Người nộp thuế theo thông báo của Cơ quan thuế' }
  ];

  const typeInvoices = [
    { value: 1, label: 'Hóa đơn điện tử NĐ123,NĐ70,NĐ254' },
    { value: 2, label: 'Hóa đơn xác thực QĐ1209' },
    { value: 3, label: 'Hóa đơn NĐ51' },
    { value: 4, label: 'Hóa đơn đặt in NĐ123' }
  ];

  const properties = [
    { value: 4, label: 'Giải trình' },
    { value: 6, label: 'Thông báo' }

  ];

  const { render: renderForm, setValue, valid: formValid, getValue } = useForm({
    fields: [
      { field: 'id', type: 'hidden' },
      { field: 'type', header: 'Loại thông báo', required: true, type: 'Dropdown', DropdownProps: { options: types, filter: true, resetFilterOnHide: true }, className: 'md:col-8', labelClassName: 'md:col-3', inputClassName: 'md:col-9' },
      { field: 'documentNo', header: 'Số thông báo', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-4', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' },
      {
        field: 'taxAuthorityNotificationNo', header: 'Số thông báo từ CQT', required: type === 2, InputTextProps: { maxLength: 400 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8', displayDependency: (item) => {
          return item.type === 2;
        }
      },
      {
        field: 'taxAuthorityNotificationDate', header: 'Ngày thông báo từ CQT', required: type === 2, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8', displayDependency: (item) => {
          return item.type === 2;
        }
      },
      { field: 'taxAuthorityCode', type: 'hidden' },
      { field: 'taxAuthorityName', header: 'Cơ quan thuế tiếp nhận', required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { type: 'custom', className: 'md:col-12', body: <i>Lưu ý: Để thông báo hoá đơn sai sót Quý khách hàng cần cập nhật đúng mã cơ quan thuế quản lý <a href="/#/he-thong/doanh-nghiep/thong-tin-doanh-nghiep" target="_blank">Tại đây</a></i> },
      { field: 'taxpayers', header: 'Tên người nộp thuế', required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'taxCode', header: 'Mã số thuế', required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'dateCreate', header: 'Ngày lập', required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'region', header: 'Nơi lập', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-6', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' }
    ],
    layout: 'Horizontal'
  });

  useEffect(() => {
    TenantCompanyService.get(AppStorage.get('tenant')).then(data => {
      setTenantData(data);
    });
  }, []);
  const columns: any = [
    {
      field: 'index', header: 'STT', style: { textAlign: 'center' }, dataType: 'custom', customCell(rowData: any, rowIndex): any {
        return rowIndex + 1;
      }
    },
    { field: 'denominator', header: 'Mẫu số *', editable: true, required: true, inputProps: { maxLength: 11 }, style: { minWidth: '100px', maxWidth: '100px' } },
    { field: 'invoiceSerial', header: 'Ký hiệu *', editable: true, required: true, inputProps: { maxLength: 6 }, style: { minWidth: '80px', maxWidth: '80px' } },
    { field: 'invoiceNumber', header: 'Số hoá đơn *', editable: true, required: true, inputProps: { maxLength: 8 }, style: { minWidth: '90px', maxWidth: '90px' } },
    { field: 'invoiceDate', header: 'Ngày hoá đơn *', editable: true, required: true, dataType: 'date', style: { minWidth: '120px', maxWidth: '120px' } },
    {
      field: 'typeInvoice', header: 'Loại hoá đơn áp dụng *', dataType: 'dropdown', editable: true, required: true, inputProps: { options: typeInvoices }, style: { minWidth: '200px', maxWidth: '200px' }
    },
    { field: 'reason', header: 'Lý do sai sót *', editable: true, required: true, style: { minWidth: '120px' }, maxLength: 255 },
    { field: 'taxAuthorityCode', header: 'Mã cơ quan thuế cấp', editable: true, style: { minWidth: '160px', maxWidth: '160px' } }
  ];

  const { render: renderDataTable, selectedItem: editingItem, setSelectedItem: setEditingItem } = useCellEditing({
    dataKey: 'invoiceId',
    columns,
    items: wrongInvoiceDetail,
    onCellChange: (rowData, column, newValue) => {
      if (['denominator', 'invoiceSerial'].includes(column.field)) {
        newValue = newValue.toUpperCase();
      }
      const _items = [...wrongInvoiceDetail];
      for (const _item of _items) {
        if (_item._id === rowData._id) {
          _item[column.field] = newValue;
        } else if (firstId === rowData._id && ['typeInvoice', 'property', 'reason'].includes(column.field)) {
          _item[column.field] = newValue;
        }
      }
      setWrongInvoiceDetail(_items);
    }
  });

  const onShow = () => {
    if (selectedItem && selectedItem.id) {
      setDisableProperty(false);
      WrongInvoiceService.getDetail(selectedItem.id).then(data => {
        if (data.dateCreate) {
          data.dateCreate = new Date(data.dateCreate);
        }
        if (data.taxAuthorityNotificationDate) {
          data.taxAuthorityNotificationDate = new Date(data.taxAuthorityNotificationDate);
        }
        if (data.wrongInvoiceDetail && data.wrongInvoiceDetail.length) {
          data.wrongInvoiceDetail.forEach((item, index) => {
            item._id = `add-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`;
            if (item.invoiceDate) {
              item.invoiceDate = new Date(item.invoiceDate);
            }
          });
          data.wrongInvoiceDetail.sort((a, b) => {
            return a.invoiceNumber - b.invoiceNumber
          });
          setFirstId(data.wrongInvoiceDetail[0]._id);
        }
        setValue(data);
        setWrongInvoiceDetail(data.wrongInvoiceDetail);
      });
    } else {
      setDisableProperty(true);
      if (tenantData) {
        TaxAuthorityService.getByCode(tenantData.taxAuthorityCode).then(res => {
          setValue({
            type: 1,
            documentNo: `TB-${FormatDisplay.date(new Date(), 'DDMMYYYY_HHmm')}`,
            taxAuthorityCode: tenantData.taxAuthorityCode,
            taxAuthorityName: res.data.name,
            taxpayers: tenantData.name,
            taxCode: tenantData.useIdentityCard ? tenantData.identityCard : tenantData.taxCode,
            region: tenantData.province,
            dateCreate: new Date()
          });
        });
      }
      setWrongInvoiceDetail([]);
    }
  }

  const addItem = () => {
    const _wrongInvoiceDetail = [...wrongInvoiceDetail];
    _wrongInvoiceDetail.push({
      _id: `add-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}`,
      denominator: '',
      invoiceSerial: '',
      invoiceNumber: '',
      invoiceDate: null,
      typeInvoice: 1,
      reason: '',
      taxAuthorityCode: ''
    });
    setWrongInvoiceDetail(_wrongInvoiceDetail);
    setFirstId(_wrongInvoiceDetail[0]._id);
  }

  const deleteItem = () => {
    if (editingItem) {
      const _wrongInvoiceDetail = wrongInvoiceDetail.filter((f) => f._id !== editingItem._id);
      setWrongInvoiceDetail(_wrongInvoiceDetail);
      setEditingItem(null);
      if (_wrongInvoiceDetail.length) {
        setFirstId(_wrongInvoiceDetail[0]._id);
      } else {
        setFirstId(null);
      }
    }
  }

  const showDialogSelectInvoice = () => {
    setDisplaySelectInvoice(true);
  }

  const onAddSelectedItems = (items) => {
    if (items) {
      let _selectedItems;
      if (Array.isArray(items)) {
        _selectedItems = [...items];
      } else {
        _selectedItems = [items];
      }
      const _items = [...wrongInvoiceDetail];
      _selectedItems.forEach((selectedItem, index) => {

        let valid = true;

        _items.forEach(_item => {
          if (_item.id === selectedItem.id) {
            valid = false;
          }
        });

        if (valid) {
          _items.push({
            _id: `add-item-${Date.now()}_${Math.floor(Math.random() * 10000) + 1}_${index}`,
            id: selectedItem.id,
            invoiceId: selectedItem.id,
            denominator: selectedItem.invoiceSerial.substring(0, 1),
            invoiceSerial: selectedItem.invoiceSerial.substring(1, selectedItem.invoiceSerial.length),
            invoiceNumber: `${selectedItem.invoiceNumber}`,
            invoiceDate: new Date(selectedItem.invoiceDate),
            typeInvoice: 1,
            reason: '',
            taxAuthorityCode: selectedItem.taxAuthorityCode || ''
          });
        }
      });
      _items.sort((a, b) => {
        return a.invoiceNumber - b.invoiceNumber
      });
      setWrongInvoiceDetail(_items);
      setFirstId(_items[0]._id);
    }
  }

  const { renderSign, sign } = useSign({ onComplete: null });

  const validateWrongInvoiceDetail = () => {
    const _invoiceDetailValidate = [];
    wrongInvoiceDetail?.forEach((wrongInvoice, index) => {
      let validates = [];

      const { denominator, invoiceSerial } = wrongInvoice;

      if (wrongInvoice.typeInvoice === 1) {
        if (!(denominator?.length === 1 && parseInt(denominator) >= 1 && parseInt(denominator) <= 6)) {
          validates.push('Mẫu số hóa đơn chỉ được nhập giá trị từ 1 đến 6');
        }

        let validate;
        if (invoiceSerial?.length !== 6) {
          validate = 'Độ dài ký hiệu hóa đơn liên quan không hợp lệ.';
        } else if (!['C', 'K'].includes(invoiceSerial[0].toUpperCase())) {
          validate = 'Ký tự hình thức hóa đơn không hợp lệ';
        } else if (invoiceSerial.length >= 3 && (Number.isNaN(parseInt(invoiceSerial[1])) || Number.isNaN(parseInt(invoiceSerial[2])))) {
          validate = 'Ký tự năm của ký hiệu không hợp lệ';
        } else if (invoiceSerial.length >= 4 && !['T', 'M', 'G', 'H', 'B', 'N'].includes(invoiceSerial[3].toUpperCase())) {
          validate = 'Ký tự loại hóa đơn không hợp lệ';
        }
        if (validate) {
          validates.push(validate);
        }
      } else {

        let validate;
        if (denominator?.length !== 11) {
          validate = 'Độ dài ký hiệu hóa đơn liên quan không hợp lệ.';
        } else if (denominator.length >= 2 && !['01', '02', '03', '04'].includes(`${denominator[0]}${denominator[1]}`)) {
          validate = 'Hai ký tự đầu về loại hóa đơn không hợp lệ';
        } else if (denominator.length >= 6 && !['GTKT', 'GTTT', 'XKNB', 'HGDL'].includes(`${denominator[2]}${denominator[3]}${denominator[4]}${denominator[5]}`.toUpperCase())) {
          validate = 'Bốn ký tự loại hóa đơn không hợp lệ';
        } else if (denominator.length >= 7 && !['0', '1', '2', '3'].includes(denominator[6])) {
          validate = 'Ký tự số liên không hợp lệ';
        } else if (denominator.length >= 8 && !['/'].includes(denominator[7])) {
          validate = 'Ký tự phân cách trong ký hiệu không hợp lệ';
        } else if (denominator.length >= 11 && !['001', '002', '003'].includes(`${denominator[8]}${denominator[9]}${denominator[10]}`)) {
          validate = 'Ba ký tự lần phát hành không hợp lệ';
        }
        if (validate) {
          validates.push(validate);
        }

        validate = '';
        if (invoiceSerial.length !== 6) {
          validate = 'Độ dài Ký hiệu hóa đơn không hợp lệ.';
        } else if (invoiceSerial.length >= 2 && (!/^[A-EG-HK-NP-TVXYZ]$/.test(invoiceSerial[0].toUpperCase()) || !/^[A-EG-HK-NP-TVXYZ]$/.test(invoiceSerial[1].toUpperCase()))) {
          validate = 'Hai ký tự đầu không hợp lệ';
        } else if (invoiceSerial.length >= 3 && !['/'].includes(invoiceSerial[2])) {
          validate = 'Ký tự phân cách không hợp lệ';
        } else if (invoiceSerial.length >= 5 && (Number.isNaN(parseInt(invoiceSerial[3])) || Number.isNaN(parseInt(invoiceSerial[4])))) {
          validate = 'Ký tự năm phát hành không hợp lệ';
        } else if (invoiceSerial.length === 6 && !['E', 'P', 'T'].includes(invoiceSerial[5].toUpperCase())) {
          validate = 'Ký tự loại hình hóa đơn không hợp lệ';
        }
        if (validate) {
          validates.push(validate);
        }
      }
      if (validates.length) {
        _invoiceDetailValidate.push(`Dòng ${index + 1}: ${validates.join('<br/> - ')}`);
      }
    });
    setInvoiceDetailValidate(_invoiceDetailValidate);
    return _invoiceDetailValidate.length;
  }

  const handleSubmit = () => {
    if (validateWrongInvoiceDetail() > 0) {
      return;
    }
    if (wrongInvoiceDetail && wrongInvoiceDetail.length) {
      let valid = true, orders = 1, _wrongInvoiceDetail = [];
      for (const wrongInvoice of wrongInvoiceDetail) {
        const _wrongInvoice = Object.assign({}, wrongInvoice);
        for (const column of columns) {
          if (column.required && (_wrongInvoice[column.field] === null || _wrongInvoice[column.field] === '')) {
            valid = false;
            ToastService.error(`${column.header} không được để trống.`);
            break;
          }
        }
        if (!valid) {
          break;
        }
        _wrongInvoice.orders = orders;
        _wrongInvoice.invoiceDate = FormatDisplay.date(_wrongInvoice.invoiceDate, 'YYYY-MM-DDTHH:mm:ss');
        orders++;
        _wrongInvoiceDetail.push(_wrongInvoice);
      }
      if (valid && formValid() && !submitting) {

        setSubmitting(true);

        const data = getValue();
        data.wrongInvoiceDetail = _wrongInvoiceDetail;

        let method;
        if (data.id) {
          method = WrongInvoiceService.update(data.id, data);
        } else {
          method = WrongInvoiceService.create(data);
        }
        method.then(({ id }) => {
          ToastService.success();
          setDisplay(false);
          reloadLazyData();

          ConfirmDialogService.setProps({
            message: 'Bạn có muốn gửi thông báo hóa đơn sai sót đến Cơ quan thuế theo mẫu 04/SS-HĐĐT ngay không?',
            header: 'Ký gửi 04/SS-HĐĐT',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-primary',
            acceptLabel: 'Đồng ý',
            rejectLabel: 'Không, Tôi sẽ gửi sau',
            accept: () => {
              sign({
                "CommandName": "SignSS04",
                "Id": data.id || id
              });
            }
          });
        }).finally(() => {
          setSubmitting(false);
        });
      }
    } else {
      ToastService.error('Danh sách hoá đơn không hợp lệ');
    }
  }

  useEffect(() => {
    setType(getValue().type)
  }, [getValue().type])

  return (
    <Fragment>
      <Dialog header="Khai báo thông tin hoá đơn sai sót" visible={display} style={{ width: '92rem' }} draggable={false} resizable={true} position="top"
        onHide={() => setDisplay(false)} onShow={onShow}>
        <div className="grid">
          <div className="col-12">
            {renderForm()}
          </div>

          <div className="col-12">
            <b>Danh sách hoá đơn cần thông báo sai sót đến Cơ quan thuế:</b>
          </div>

          {invoiceDetailValidate?.length > 0 && <div className="col-12">
            <div className="p-message p-component p-message-error p-message-enter-done m-0">
              <div className="p-message-wrapper">
                <span className="p-message-detail">
                  {invoiceDetailValidate.map((validate, index) => <div key={index} dangerouslySetInnerHTML={{ __html: validate }}></div>)}
                </span>
              </div>
            </div>
          </div>}

          <div className="col-fixed" style={{ width: '300px' }}>
            <Button label="Chọn hoá đơn" className="p-button-outlined p-button-sm mr-2" onClick={showDialogSelectInvoice} />
            <Button label="Thêm dòng" className="p-button-outlined p-button-success p-button-sm mr-2" onClick={addItem} />
            <Button label="Xoá dòng" className="p-button-outlined p-button-danger p-button-sm" onClick={deleteItem}
              disabled={!editingItem} />
          </div>
          <div className="col flex align-items-center">
            <i>(Chọn hoá đơn có sẵn trên phần mềm hoặc Thêm dòng để nhập thủ công hoá đơn NCC khác, hoá đơn Thông tư 32)</i>
          </div>
          <div className="col-12">
            {renderDataTable()}
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label="Đóng" icon="pi pi-times" onClick={() => {
            setDisplay(false);
            setInvoiceDetailValidate(null);
          }} className="p-button-text p-button-sm" />
          <Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm" />
        </div>
      </Dialog>
      <DialogSelectInvoice display={displaySelectInvoice} setDisplay={setDisplaySelectInvoice} addSelectedItems={onAddSelectedItems} selectionMode="checkbox"
        sendTaxStatus="4" />
      {renderSign()}
    </Fragment>
  );
}